import { nanoid } from 'nanoid';
import { s } from '@kosmod/pancake';

const keySymbol = Symbol()
const prefixSymbol = Symbol()

export type ID<TKey extends string, TRequirePrefix extends boolean = true> =
  & string
  & { [key in typeof keySymbol]: TKey }
  & { [key in typeof prefixSymbol]: TRequirePrefix }

const ID_SIZE = 16;
const PREFIX_JOINER = `:`

export function ID<TKey extends string>(prefix: TKey, suffix?: string): ID<TKey, true>;
export function ID<TKey extends string>(): ID<TKey, false>;
export function ID(prefix?: string, suffix?: string): any {
  if (prefix)
    return `${prefix}${PREFIX_JOINER}${nanoid(ID_SIZE)}${suffix && PREFIX_JOINER || ''}${suffix || ''}`;

  return nanoid(ID_SIZE);
}

export const idDef = s.ref<ID<any, true>, "force">()(s.str);